import { Card, CardHeader, Col, Label, Row } from "reactstrap";
import { useTranslation } from "react-i18next";
import { useState } from "react";
import Select from "react-select";
import { UserListTableData } from "../../../data/users/UsersList";
import { UserListTableDataColumnType } from "../../../types/users/UserTypes";
 import { Image } from "../../../AbstractElements";
import { dynamicImage } from "../../../service";
import { FilterSearchSectionProps } from "../../../types/organization/OrganizationList";
import SearchBox from "../search-bar/SearchBox";

function FilterSearchSection({
  hideOrganization = false,
  showUserActions = false,
  onAddUser,
  onInvite,
}: FilterSearchSectionProps) {
  const { t } = useTranslation();
  const [selectedName, setSelectedName] = useState("");
  const [selectedOrg, setSelectedOrg] = useState("");
  const [selectedStatus, setSelectedStatus] = useState("");
  const [selectedGender, setSelectedGender] = useState("");

  const organizations = Array.from(
    new Set(
      (UserListTableData as UserListTableDataColumnType[])
        .map((u: UserListTableDataColumnType) => u.organizationname || "")
        .filter(Boolean)
    )
  );
  const statuses = Array.from(
    new Set(
      (UserListTableData as UserListTableDataColumnType[])
        .map((u: UserListTableDataColumnType) => u.status || "")
        .filter(Boolean)
    )
  );
  const genders = Array.from(
    new Set(
      (UserListTableData as UserListTableDataColumnType[])
        .map((u: UserListTableDataColumnType) => u.gender || "")
        .filter(Boolean)
    )
  );

  const organizationLogoMap = (
    UserListTableData as UserListTableDataColumnType[]
  ).reduce((acc, user) => {
    if (user.organizationname && user.logo) {
      acc[user.organizationname] = user.logo;
    }
    return acc;
  }, {} as Record<string, string>);

  const nameOptions = (UserListTableData as UserListTableDataColumnType[])
    .filter((u: UserListTableDataColumnType) => u.name)
    .map((u: UserListTableDataColumnType) => ({
      value: u.name!,
      label: u.name!,
      image: u.image || "",
    }));
  const organizationOptions = organizations.map((org) => ({
    value: org,
    label: org,
    logo: organizationLogoMap[org] || "",
  }));
  const statusOptions = statuses.map((status) => ({
    value: status,
    label: status,
  }));
  const genderOptions = genders.map((gender) => ({
    value: gender,
    label: gender,
  }));
  return (
    <div className="feature-products">
      <Row>
        <SearchBox
          showUserActions={showUserActions}
          onAddUser={onAddUser}
          onInvite={onInvite}
        />
        <Col xl="12">
          <Card>
            <div >
              <CardHeader>
                <div className="mb-2">
                  <Row>
                    {hideOrganization ? (
                      <>
                        <Col sm="4">
                          <Label>{t("Name")}</Label>
                          <Select
                            options={nameOptions}
                            placeholder={t("selectName")}
                            className="basic-single-select"
                            classNamePrefix="select"
                            isSearchable={true}
                            isClearable
                            value={
                              selectedName
                                ? nameOptions.find(
                                    (option) => option.value === selectedName
                                  ) || {
                                    value: selectedName,
                                    label: selectedName,
                                  }
                                : null
                            }
                            onChange={(option) =>
                              setSelectedName(option ? option.value : "")
                            }
                            formatOptionLabel={(option: any) => (
                              <div className="d-flex align-items-center">
                                {option.image && (
                                  <Image
                                    src={dynamicImage(option.image)}
                                    alt={option.label}
                                    style={{
                                      width: 30,
                                      height: 30,
                                      borderRadius: "50%",
                                      marginRight: 8,
                                    }}
                                  />
                                )}
                                <span>{option.label}</span>
                              </div>
                            )}
                          />
                        </Col>
                        <Col sm="4">
                          <Label>{t("Status")}</Label>
                          <Select
                            options={statusOptions}
                            placeholder={t("selectStatus")}
                            className="basic-single-select"
                            classNamePrefix="select"
                            isSearchable={true}
                            isClearable
                            value={
                              selectedStatus
                                ? {
                                    value: selectedStatus,
                                    label: selectedStatus,
                                  }
                                : null
                            }
                            onChange={(option) =>
                              setSelectedStatus(option ? option.value : "")
                            }
                          />
                        </Col>
                        <Col sm="4">
                          <Label>{t("Gender")}</Label>
                          <Select
                            options={genderOptions}
                            placeholder={t("selectGender")}
                            className="basic-single-select"
                            classNamePrefix="select"
                            isSearchable={true}
                            isClearable
                            value={
                              selectedGender
                                ? {
                                    value: selectedGender,
                                    label: selectedGender,
                                  }
                                : null
                            }
                            onChange={(option) =>
                              setSelectedGender(option ? option.value : "")
                            }
                          />
                        </Col>
                      </>
                    ) : (
                      <>
                        <Col sm="3">
                          <Label>{t("Name")}</Label>
                          <Select
                            options={nameOptions}
                            placeholder={t("selectName")}
                            className="basic-single-select"
                            classNamePrefix="select"
                            isSearchable={true}
                            isClearable
                            value={
                              selectedName
                                ? nameOptions.find(
                                    (option) => option.value === selectedName
                                  ) || {
                                    value: selectedName,
                                    label: selectedName,
                                  }
                                : null
                            }
                            onChange={(option) =>
                              setSelectedName(option ? option.value : "")
                            }
                            formatOptionLabel={(option: any) => (
                              <div className="d-flex align-items-center">
                                {option.image && (
                                  <Image
                                    src={dynamicImage(option.image)}
                                    alt={option.label}
                                    style={{
                                      width: 30,
                                      height: 30,
                                      borderRadius: "50%",
                                      marginRight: 8,
                                    }}
                                  />
                                )}
                                <span>{option.label}</span>
                              </div>
                            )}
                          />
                        </Col>
                        {!hideOrganization && (
                          <Col sm="3">
                            <Label>{t("OrganizationName")}</Label>
                            <Select
                              options={organizationOptions}
                              placeholder={t("OrganizationNamePlaceholder")}
                              className="basic-single-select"
                              classNamePrefix="select"
                              isSearchable={true}
                              isClearable
                              value={
                                selectedOrg
                                  ? {
                                      value: selectedOrg,
                                      label: selectedOrg,
                                      logo:
                                        organizationLogoMap[selectedOrg] || "",
                                    }
                                  : null
                              }
                              onChange={(option) =>
                                setSelectedOrg(option ? option.value : "")
                              }
                              formatOptionLabel={(option: any) => (
                                <div className="d-flex align-items-center">
                                  {option.logo && (
                                    <Image
                                      src={dynamicImage(option.logo)}
                                      alt={option.label}
                                      style={{
                                        width: 30,
                                        height: 30,
                                        borderRadius: "50%",
                                        marginRight: 8,
                                      }}
                                    />
                                  )}
                                  <span>{option.label}</span>
                                </div>
                              )}
                            />
                          </Col>
                        )}
                        <Col sm="3">
                          <Label>{t("Status")}</Label>
                          <Select
                            options={statusOptions}
                            placeholder={t("selectStatus")}
                            className="basic-single-select"
                            classNamePrefix="select"
                            isSearchable={true}
                            isClearable
                            value={
                              selectedStatus
                                ? {
                                    value: selectedStatus,
                                    label: selectedStatus,
                                  }
                                : null
                            }
                            onChange={(option) =>
                              setSelectedStatus(option ? option.value : "")
                            }
                          />
                        </Col>
                        <Col sm="3">
                          <Label>{t("Gender")}</Label>
                          <Select
                            options={genderOptions}
                            placeholder={t("selectGender")}
                            className="basic-single-select"
                            classNamePrefix="select"
                            isSearchable={true}
                            isClearable
                            value={
                              selectedGender
                                ? {
                                    value: selectedGender,
                                    label: selectedGender,
                                  }
                                : null
                            }
                            onChange={(option) =>
                              setSelectedGender(option ? option.value : "")
                            }
                          />
                        </Col>
                      </>
                    )}
                  </Row>
                </div>
              </CardHeader>
            </div>
          </Card>
        </Col>
      </Row>
    </div>
  );
}

export default FilterSearchSection;
